import { render, staticRenderFns } from "./vliveGuideCover.vue?vue&type=template&id=1320a3c0&"
import script from "./vliveGuideCover.vue?vue&type=script&lang=js&"
export * from "./vliveGuideCover.vue?vue&type=script&lang=js&"
import style0 from "./vliveGuideCover.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports